import React from 'react'
import { useParams } from 'react-router';
import { useState } from 'react';
import ChangepasswordForm from '../../../../components/others/global/changepassword';
import Profile from './profile';
import Listings from './listings';
import Orders from './orders';

const Index = () => {
    const {username} = useParams();
    const [page,setPage] = useState(0);
  return (
    <>
        <div className='admin_forms_row'>
            <div className='admin_col_70'>
                <Profile username = {username}/>
            </div>
            <div className='admin_col_30'>
                <ChangepasswordForm Username = {username} Admin = {true}/>
            </div>
        </div>
        <div className='public_home_pagesswitch_container'>
            <div className={page === 0?'public_home_exploretab_container active':'public_home_exploretab_container'} onClick={
                ()=>{setPage(0);}
            }>
                <h5>Posts</h5>
            </div>
            <div className={page === 1?'public_home_feedtab_container active':'public_home_feedtab_container'} onClick={
                ()=>{setPage(1);}
            }>
                <h5>Orders</h5>
            </div>
        </div>
        {page === 0 &&
            <Listings username={username}/>
        }
        {page === 1 &&
            <div style={{paddingTop:"20px"}}>
            <Orders username={username}/>
            </div>
        }
    </>
  )
}

export default Index
